export default __webpack_public_path__ + "static/media/player-leah-colour-desk.5349add0.png";